import { Controller } from "@hotwired/stimulus"

// Guards the one action on the land form that destroys work. Cancel and the
// back link leave without saving, so once any field has changed they ask
// first. Submitting is not a loss, so it clears the guard.
export default class extends Controller {
  static targets = ["form", "dialog"]

  connect() {
    this.dirty = false
    this.pendingUrl = null
    this.snapshot = this.#serialize()
    this.element.addEventListener("input", this.#markDirty)
    this.element.addEventListener("change", this.#markDirty)
  }

  disconnect() {
    this.element.removeEventListener("input", this.#markDirty)
    this.element.removeEventListener("change", this.#markDirty)
  }

  confirmLeave(event) {
    if (!this.dirty) return

    event.preventDefault()
    this.pendingUrl = event.currentTarget.href
    this.dialogTarget.showModal()
  }

  keepEditing() {
    this.dialogTarget.close()
    this.pendingUrl = null
  }

  discard() {
    this.dirty = false
    this.dialogTarget.close()
    if (this.pendingUrl) window.location.href = this.pendingUrl
  }

  allowLeave() {
    this.dirty = false
  }

  // Comparing against a snapshot rather than flipping a flag on first input,
  // so typing a character and undoing it does not leave the form "dirty".
  #markDirty = () => {
    this.dirty = this.#serialize() !== this.snapshot
  }

  #serialize() {
    if (!this.hasFormTarget) return ""
    return new URLSearchParams(new FormData(this.formTarget)).toString()
  }
}
